import React from "react";
import CommitteeApprovalAssignmentList from "../../../features/CommitteeApproval/components/CommitteeApprovalAssignmentList";


const CommitteeApprovalAssignment = () => {
  return (
   <>
   <CommitteeApprovalAssignmentList/>
   </>
  );
};

export default CommitteeApprovalAssignment;
